const timeValuePattern = /^([01]?\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/;

const getValidDate = (dateValue) => {
  const date = dateValue instanceof Date ? new Date(dateValue) : new Date(dateValue || Date.now());
  return Number.isNaN(date.getTime()) ? new Date() : date;
};

export const formatEventTimeValue = (timeValue, dateValue) => {
  if (!timeValue) {
    return '';
  }

  if (timeValue instanceof Date) {
    return timeValue.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
  }

  const trimmedTime = String(timeValue).trim();
  const timeMatch = trimmedTime.match(timeValuePattern);

  if (timeMatch) {
    const displayDate = getValidDate(dateValue);
    displayDate.setHours(Number(timeMatch[1]), Number(timeMatch[2]), 0, 0);
    return displayDate.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
  }

  const parsedTime = new Date(trimmedTime);
  if (!Number.isNaN(parsedTime.getTime())) {
    return parsedTime.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
  }

  return trimmedTime;
};

export const formatEventTimeRange = (event) => {
  const startTime = formatEventTimeValue(event?.startTime, event?.date);
  const endTime = formatEventTimeValue(event?.endTime, event?.endDate || event?.date);

  if (startTime && endTime) {
    return `${startTime} - ${endTime}`;
  }

  if (startTime) {
    return startTime;
  }

  const eventDate = new Date(event?.date);
  return Number.isNaN(eventDate.getTime())
    ? ''
    : eventDate.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
};